import React from "react";
import "./Practice.css";

const Practices = () => {
  return (
    <div className="practices-bg-color practices-padding">
      <div id="practices-container">
        <div id="practices-header">You are always in the loop</div>
        <div className="row">
          <div className="col-md-12 col-lg-4 col-xl-4 col-sm-12">
            <div className="practices-box" id="practices-box-1" data-aos="zoom-in">
              <div className="practices-number">1.</div><div className="practices-box-header">Predictable <br/> Results</div>
              <p className="practices-box-body">Our first focus is planning and designing then finish the projects to successful and predictable results. We listen to all your requirements and produce the application within budget and on time.</p>
            </div>
          </div>
          <div className="col-md-12 col-lg-4 col-xl-4 col-sm-12">
            <div className="practices-box" id="practices-box-2" data-aos="zoom-in">
              <div className="practices-number">2.</div><div className="practices-box-header">Daily <br/> Status Update</div>
              <p className="practices-box-body">Our work will be transparent and we keep our clients involved in the development process daily. we do frequent checkpoints it help us provide better visibility of our processes and avoid miscommunication and expectations mismatch.</p>
            </div>
          </div>
          <div className="col-md-12 col-lg-4 col-xl-4 col-sm-12">
            <div className="practices-box" id="practices-box-3" data-aos="zoom-in">
              <div className="practices-number">3.</div><div className="practices-box-header">Detailed<br/>Reports</div>
              <p className="practices-box-body">We send our clients detailed reports supported with demonstrations of the project. We update them with every steps so they have full control over their projects.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Practices;




// WEBPACK FOOTER //
// ./src/components/Services/Practices/Practices.js